import { STORE, CLEAR } from '../actions/miscPermissionAction'
let initialState = []

export default function miscPermission(state = initialState, action) {
    switch (action.type) {
        case STORE: return action.payload
        case CLEAR: return []
        default: return state
    }
}